/* eslint-disable */
/* this file is generated by generateIcons script */

import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class RepositoriesIcon extends BaseIcon {
  getChildren = () => [ <path d="M8.5,11c-3,0-5.5-.9-5.5-2v3a1,1,0,0,0,.17.52A.8.8,0,0,0,3,13c0,1.1,2.46,2,5.5,2s5.5-.9,5.5-2a.8.8,0,0,0-.17-.48A1,1,0,0,0,14,12V9C14,10.1,11.54,11,8.5,11ZM14,3c0-1.1-2.46-2-5.5-2S3,1.9,3,3a.82.82,0,0,0,.11.39A1.78,1.78,0,0,0,3,4V5a.9.9,0,0,1,.18-.5C3.79,5.36,5.94,6,8.5,6s4.71-.64,5.32-1.5A.9.9,0,0,1,14,5V4a1.78,1.78,0,0,0-.11-.61A.82.82,0,0,0,14,3ZM8.5,7C5.46,7,3,6.1,3,5V9a.9.9,0,0,1,.18-.5C3.79,9.36,5.94,10,8.5,10s4.71-.64,5.32-1.5A.9.9,0,0,1,14,9V5C14,6.1,11.54,7,8.5,7Z" fill={this.getColor()}/> ]
  getViewBox = () => '0 0 16 16'
}
